import type { TipoEntrega } from "./pedidoOperacional";

/** Resposta dos POSTs de retirada / entrega no evento. */
export type RetiradaPedidoActionResponse = {
  success: boolean;
  message: string;
  data?: {
    id: string;
    tipoEntrega?: string;
    status?: string;
    statusRetirada?: string | null;
    [key: string]: unknown;
  };
};

export type ConfirmarRetiradaPedidoBody = {
  nomeRecebedor: string;
  documentoRecebedor?: string;
  telefoneRecebedor?: string;
};

/** Snapshot opcional no GET pedido gerencial. */
export interface IRetiradaPedidoSnapshot {
  id?: string;
  tipo?: string;
  status?: string;
  eventoId?: number | null;
  codigoRetirada?: string | null;
  nomeRecebedor?: string | null;
  documentoRecebedor?: string | null;
  telefoneRecebedor?: string | null;
  retiradoEm?: string | null;
  confirmadoPorUserId?: string | null;
  observacao?: string | null;
  confirmadoPor?: { nome?: string | null; email?: string | null } | null;
  evento?: { id: number; titulo?: string | null } | null;
}

/** Textos da UI conforme tipo de entrega (loja vs evento). */
export function copyRetiradaUi(tipo: TipoEntrega | string | null | undefined) {
  const evento = tipo === "RETIRADA_EVENTO";
  return {
    pageSubtitle: evento ? "Entrega no evento" : "Retirada na loja",
    situacaoTitulo: evento
      ? "Situação da entrega no evento"
      : "Situação da retirada",
    btnPronto: evento
      ? "Marcar pronto para entrega no evento"
      : "Marcar pronto para retirada",
    btnConfirmar: evento
      ? "Confirmar entrega no evento"
      : "Confirmar retirada",
    recebedorLabel: evento ? "Participante / quem recebe" : "Quem retira (recebedor)",
    docLabel: evento ? "Documento" : "Documento do recebedor",
    telLabel: evento ? "Telefone" : "Telefone do recebedor",
    codigoLabel: evento ? "Código de retirada / kit" : "Código de retirada",
    concluidoTitulo: evento
      ? "Entrega no evento concluída"
      : "Retirada concluída",
    concluidoTexto: evento
      ? "O pedido foi registrado como entregue no evento."
      : "O pedido foi registrado como retirado na loja.",
    preparacaoHint: evento
      ? "Avise quando o kit estiver disponível para entrega no evento."
      : "Avise quando o pedido estiver disponível para retirada na loja.",
    confirmHint: evento
      ? "Registre quem recebeu o material no evento."
      : "Registre quem retirou o pedido e confira os dados.",
    resumoNome: evento ? "Participante / recebedor" : "Quem retira",
    resumoDoc: evento ? "Documento" : "Documento do recebedor",
    resumoTel: evento ? "Telefone" : "Telefone do recebedor",
    resumoData: evento ? "Data da entrega no evento" : "Data da retirada",
  };
}
